import Loader from "react-loader-spinner";
import { useState } from "react";
import { exportToExcel } from "../../../store/api/CommonFunctions";
import { Button } from "react-bootstrap";
import { FileEarmarkExcelFill, FileX, FileXFill } from "react-bootstrap-icons";

export default function ExcelButton({ actionUrl, filterData, tableCols, style }) {
    const [isPending, setIsPending] = useState(false);
    const toExcel = () => {
        const url = `api/WorkItemsApi/${actionUrl}`;
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setIsPending(true);
        exportToExcel(actionUrl, searchArgs, url, "post", tableCols, () => setIsPending(false));
    }
    return (
        <button type="button" onClick={toExcel} className="btn p-0" style={{...style}}>
            {isPending ?
                <Loader type="TailSpin" color="green" width={16} height={16} style={{ display: "inline-block" }}  /> :
                <FileEarmarkExcelFill size={23} color="green"/>
            }&nbsp;
        </button>
    )
}